import { render, staticRenderFns } from "./treatmentplanList.vue?vue&type=template&id=8140a82a&"
import script from "./treatmentplanList.vue?vue&type=script&lang=js&"
export * from "./treatmentplanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports